import { memo } from "react";
import { generatePath, Link } from "react-router";

import { PATHS } from "@/routes/paths";

import { ExternalLink } from "@/components/ui/button/external-link";

import { TestReservation } from "@/components/features-new/hotel-top/components/island/hotel-urls/test-reservation";

type Props = {
	hotelID: string;
	isTestReservationAvailable: boolean;
};

const FAQ_NOTION_ID = "e2ff2cd1c07e46d58a0db4450f800c06";

export const Step1 = memo(({ hotelID, isTestReservationAvailable }: Props) => {
	return (
		<section className="space-y-4">
			<h3 className="border-b border-zinc-200 pb-2 text-base font-bold">
				STEP1. 公開前にテスト予約をしてみましょう
			</h3>
			<div className="space-y-3 text-sm leading-relaxed text-zinc-700">
				<p>
					テスト予約では、
					<span className="font-bold">クレジットカード情報を入力せずにテスト予約</span>
					を行うことができます。
				</p>
				<p>販売開始前に、下記ボタンより必ず一度はテスト予約を実施してください。</p>
				<TestReservation hotelID={hotelID} isTestReservationAvailable={isTestReservationAvailable} />
				<p>
					万が一、テスト予約が行えない場合は
					<ExternalLink href="https://typebot.co/chillnn-reservation-test-y04lb9k" text="こちら" />
					で原因の診断をお試しください。
				</p>
				<div>
					<span className="text-zinc-500">参考）</span>
					<Link
						to={generatePath(PATHS.FAQ_DETAIL, { hotelID, notionID: FAQ_NOTION_ID })}
						target="_blank"
						className="text-link-400 underline-offset-4 hover:underline"
					>
						販売ができない理由は？
					</Link>
				</div>
			</div>
		</section>
	);
});

Step1.displayName = "Step1";
